module.exports = __webpack_public_path__ + "img/zk-icon-menu.32b44cf1.svg";